var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 312 220",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0.043137 0.043137"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0.070588 0.070588"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0.164706 0.164706"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.160784,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "6.875000 6.875000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.09528,
    y: 0.964478,
    width: 302.346,
    height: 210.812
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-669 -957)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    filter: "url(#fx0)",
    transform: "translate(670 959)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.983 21.5895 282.816 106.319 198.086 191.152 198.061 148.761 21.7716 148.868 21.7202 64.0868 198.009 63.98Z",
    fill: "#34BECD",
    fillRule: "evenodd",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M867.984 980.589 952.816 1065.32 868.086 1150.15 868.061 1107.76 691.772 1107.87 691.72 1023.09 868.009 1022.98Z",
    fill: "#34BECD",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiArrowBlue);
export default __webpack_public_path__ + "static/media/ai-arrow-blue.452ae1b29e103101fabd38567445902e.svg";
export { ForwardRef as ReactComponent };